import {
  SET_INSIGHTS_CRITERIA_TYPE,
  SET_INSIGHTS_CRITERIA_DATE_RANGE,
  SET_INSIGHTS_CRITERIA_ORGANISATION,
  SET_INSIGHTS_CRITERIA_SUBCATEGORY,
  SET_INSIGHTS_CRITERIA_BOUNDARIES,
  SET_INSIGHTS_CRITERIA_POI,
  SET_INSIGHTS_CRITERIA_MOBILE_APP,
  SET_FROM_LAST_PAGE,
  CLEAR_INSIGHTS_CRITERIA_BOUNDARIES,
  CLEAR_INSIGHTS_CRITERIA,
  CLEAR_INSIGHTS_CRITERIA_POIS,
  CLEAR_INSIGHTS_CRITERIA_MOBILE_APP,
  TOGGLE_STATISTIC_DISPLAY
} from '../constants';

export const setInsightsCriteriaDateRange = (sinceDate, untilDate) => ({
  type: SET_INSIGHTS_CRITERIA_DATE_RANGE,
  sinceDate,
  untilDate,
});

export const setInsightsCriteriaOrganisation = (organisation, subcategory) => ({
  type: SET_INSIGHTS_CRITERIA_ORGANISATION,
  organisation,
  subcategory,
});

export const setInsightsCriteriaSubcategory = subcategory => ({
  type: SET_INSIGHTS_CRITERIA_SUBCATEGORY,
  subcategory,
});

export const setInsightsCriteriaBoundaries = boundaries => ({
  type: SET_INSIGHTS_CRITERIA_BOUNDARIES,
  boundaries,
});

export const setInsightsCriteriaPoi = poiId => ({
  type: SET_INSIGHTS_CRITERIA_POI,
  poiId,
});

export const setInsightsCriteriaMobileApps = mobileApp => ({
  type: SET_INSIGHTS_CRITERIA_MOBILE_APP,
  mobileApp,
});

export const clearInsightsCriteria = () => ({
  type: CLEAR_INSIGHTS_CRITERIA,
});

export const clearInsightsCriteriaBoundaries = () => ({
  type: CLEAR_INSIGHTS_CRITERIA_BOUNDARIES,
});

export const clearInsightsCriteriaPois = () => ({
  type: CLEAR_INSIGHTS_CRITERIA_POIS,
});

export const clearInsightsCriteriaMobileApps = () => ({
  type: CLEAR_INSIGHTS_CRITERIA_MOBILE_APP,
});

export const setInsightsCriteriaType = insightType => ({
  type: SET_INSIGHTS_CRITERIA_TYPE,
  insightType,
})

export const setFromLastPage = lastPage => ({
  type: SET_FROM_LAST_PAGE,
  lastPage,
})

export const toggleStatisticDisplay = () => ({
  type: TOGGLE_STATISTIC_DISPLAY,
})
